<div *ngIf="open" class="fixed inset-0 z-[1000] flex items-center justify-center">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/40" (click)="onBackdropClick()"></div>
  <!-- Panel -->
  <div class="relative bg-white rounded-md shadow-lg" [style.width]="width" [style.max-width]="'90vw'">
    <ng-content></ng-content>
  </div>
</div>
